function severityLevelFromString(level) {
  return level === "warn" ? "warning" : ["fatal", "error", "warning", "log", "info", "debug"].includes(level) ? level : "log";
}

export { severityLevelFromString };
//# sourceMappingURL=severity.js.map
